import moment from "jalali-moment";
import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import useFetch from "../../../Hooks/useFetch";
import { BtnPrimary } from "../../share/buttons/Btn";
import MessageQuill from "./MessageQuill";

const DashboardAnswer = ({ setNewTicket, setTicketAnswer, id, subject }) => {
    const [ticket, setTicket] = useState();
    const [message, setMessage] = useState();
    const [call, setCall] = useState();

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const onClickHandler = () => {
        setNewTicket(true);
        setTicketAnswer(false);
    };

    const getSingleTicket = useFetch({
        method: "GET",
        url: `TicketService/${id}`,
        noHeader: false,
        trigger: false,
        setter: setTicket,
    });

    const newResponseTicket = useFetch({
        method: "POST",
        url: `TicketMessageService/send_response`,
        noHeader: false,
        caller: getSingleTicket,
        trigger: false,
        data: call,
    });

    const onSubmit = () => {
        const formData = new FormData();

        formData.append("text", message);
        formData.append("ticket", id);

        setCall(formData);

        newResponseTicket.reFetch();

        newResponseTicket.status === 201 && setMessage("");
    };

    // useEffect(() => {
    //     newResponseTicket.status === 201 && setMessage("");
    // }, getSingleTicket);

    useEffect(() => {
        getSingleTicket.reFetch();
    }, [id]);
    // useEffect(() => {
    //     // console.log(ticket);
    // }, [ticket]);

    return (
        <div className="AddnewsupportTicket relative ">
            <button
                onClick={() => setTicketAnswer(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            {ticket?.messages.results.map((i) => {
                return (
                    <div
                        id={i.id}
                        className="mb-16 border-b-2 border-gray pb-8"
                    >
                        <h3 className=" text-center text-[#77498F] text-[16px] ">
                            تیکت پشتیبانی
                        </h3>

                        <div className=" mt-[5.6rem]">
                            <div className=" grid grid-cols-2 gap-x-0 gap-y-[1.3rem]">
                                <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem]">
                                    ارسال کننده:
                                </p>
                                <p className=" text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem]">
                                    {i.is_from_user
                                        ? Cookies.get("username")
                                        : "پشتیبانی"}
                                </p>

                                <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem]">
                                    موضوع:
                                </p>
                                <p className=" text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem]">
                                    {subject}
                                </p>
                                <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem]">
                                    تاریخ ارسال تیکت:
                                </p>
                                <p className=" text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem]">
                                    {moment(i.created_at)
                                        .locale("fa", {
                                            useGregorianParser: true,
                                        })
                                        .format("HH:mm:ss YYYY/MM/DD")}
                                </p>
                            </div>
                            <div className=" mt-[1.5rem]">
                                <p className=" text-black  font-normal text-[1.8rem] leading-[3.2rem] mb-4">
                                    پیام:
                                </p>
                                <p className="whitespace-pre-line text-[#212121E5]  font-normal text-[1.4rem] leading-[2.4rem] bg-white p-4 rounded-3xl">
                                    {i.text}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            })}
            <p className=" text-black  font-normal text-[1.8rem] leading-[3.2rem] mb-4">
                پیام جدید:
            </p>
            <form onSubmit={handleSubmit(onSubmit)}>
                <MessageQuill
                    setValue={setMessage}
                    value={message}
                    placeholder={"نوشتن پاسخ"}
                />
                <div className="text-left mt-[3rem]">
                    <BtnPrimary
                        text="ارسال تیکت روی این پاسخ"
                        type="submit"
                        className="px-16 py-7 "
                    />
                </div>
            </form>
        </div>
    );
};

export default DashboardAnswer;
